document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.getElementById('search-icon');
  const searchInput = document.getElementById('SearchInput');
  const predictiveSearch = document.getElementById('predictive-search');
  searchIcon.addEventListener('click', function (event) {
    event.preventDefault();
    searchInput.style.display = 'inline-block';
    searchInput.classList.add('show');
    searchInput.focus();
  });

  searchInput.addEventListener('input', function () {
    const searchTerm = searchInput.value;

    if (searchTerm.length > 2) {
      fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product`)
        .then((response) => response.json())
        .then((data) => {
          let resultsHtml = '';
          if (data.resources.results.products.length > 0) {
            data.resources.results.products.forEach((product) => {
              resultsHtml += `
                            <div class="search-result">
                                <a href="${product.url}">
                                    <img loading="lazy" src="${product.featured_image.url}" alt="${product.title}" />
                                    <span>${product.title}</span>
                                </a>
                            </div>`;
            });
          } else {
            resultsHtml = '<p>No products found</p>';
          }

          predictiveSearch.innerHTML = resultsHtml;
          predictiveSearch.style.display = 'block';
        });
    } else {
      predictiveSearch.style.display = 'none';
    }
  });
});

//window.addEventListener('load', function () {
// document.getElementById('loader').style.display = 'none';
//});

$(document).ready(function () {
  var cookie = Cookies.get('apbloem-cookie');
  if (cookie) {
    $('.cookies').css('display', 'none');
  }

  function verificarExibirPopup() {
    var popupExibidoCookie = Cookies.get('popup_exibido');

    if (!popupExibidoCookie) {
      var numPaginasVisitadasCookie = Cookies.get('num_paginas_visitadas');
      var numPaginasVisitadas = parseInt(numPaginasVisitadasCookie) || 0;
      numPaginasVisitadas++;
      Cookies.set('num_paginas_visitadas', numPaginasVisitadas, { expires: 1 });

      if (numPaginasVisitadas >= 2) {
        exibirPopupAposTempo();
        return;
      } else {
        setTimeout(function () {
          exibirPopupAposTempo();
        }, 60000);
      }
    }
  }

  $('.cookies-close').click(function () {
    Cookies.set('apbloem-cookie', true, {
      expires: 7,
      path: '',
    });
    Cookies.set('apbloem-opt-out', true, {
      expires: 7,
      path: '',
    });
    $('.cookies').css('opacity', '0');
    $('.cookies').css('pointer-events', 'none');
    $('.cookies').css('display', 'none');
  });

  $('.cookies-accept').click(function () {
    Cookies.set('apbloem-cookie', true, {
      expires: 7,
      path: '',
    });
    Cookies.set('apbloem-opt-in', true, {
      expires: 7,
      path: '',
    });
    $('.cookies').css('opacity', '0');
    $('.cookies').css('pointer-events', 'none');
    $('.cookies').css('display', 'none');
  });
});

document.addEventListener(
  'scroll',
  function () {
    const scrollThreshold = 250;
    const fixedElement = $('.fixedTop');

    if (window.scrollY > scrollThreshold) {
      fixedElement.addClass('fixed-top');
    } else {
      fixedElement.removeClass('fixed-top');
    }
  },
  { passive: true }
);
